import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const hiddenStyles = {
  height: 0,
};

export const hiddenStylesDesktop = {
  height: 0,
  width: 0,
  opacity: 0,
};

type ProductOverviewContainerProps = BoxProps & {
  backgroundColor?: string;
};

export const ProductOverviewContainer = ({
  backgroundColor,
  style,
  ...props
}: ProductOverviewContainerProps) => (
  <Box {...props} style={[styles.productOverviewContainer, { backgroundColor }, style]} />
);

const styles = StyleSheet.create({
  productOverviewContainer: {
    width: '100%',
  },
});
